import { render, staticRenderFns } from "./scholarTrend.vue?vue&type=template&id=30344e49&scoped=true"
import script from "./scholarTrend.vue?vue&type=script&lang=js"
export * from "./scholarTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30344e49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30344e49')) {
      api.createRecord('30344e49', component.options)
    } else {
      api.reload('30344e49', component.options)
    }
    module.hot.accept("./scholarTrend.vue?vue&type=template&id=30344e49&scoped=true", function () {
      api.rerender('30344e49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/details/comps/scholarTrend.vue"
export default component.exports